module.exports = __webpack_public_path__ + "static/media/kuibishan_plant.2e6c49f4.png";